import { h, Fragment } from "preact";
import { useEffect, useRef, useState } from "preact/hooks";
import register from "preact-custom-element";
import useProducts from "../helpers/useProducts/useProducts";
import ShoppableImageProduct from "./shoppable-image-product";

function ShoppableImage({ src, alt, handles }) {
  const products = useProducts(handles.split(","));

  return (
    <div className="shoppable-image">
      <img
        src={src}
        alt={alt}
        className="styled-article-image shoppable-image__image"
      />
      <div className="shoppable-image__products">
        {products.map((product) => (
          <ShoppableImageProduct
            product={product}
            key={product.id}
          ></ShoppableImageProduct>
        ))}
      </div>
    </div>
  );
}

if (!customElements.get("shoppable-image")) {
  register(ShoppableImage, "shoppable-image", ["src", "alt", "handles"], {
    shadow: false,
  });
}
